import PasswordResetForm from "@/components/PrivateComponente/PasswordResetForm";

const ResetPassword = () => {
  return (
    <div>
      <PasswordResetForm />
    </div>
  );
};

export default ResetPassword;
